<template>
  <div class="app flex-row auth-page">
    <div class="container-fluid">

      <b-row>
        <b-col md="7" class="auth-hero-column d-none d-md-block">
          <BrandLoginHero />
        </b-col>

        <b-col md="5" class="auth-panel-column">
          <main class="auth-panel">
            <div class="auth-brand">
            <BrandLoginHero compact />
            </div>

            <b-card no-body class="auth-card">
              <b-card-body class="auth-card-body">
              <div v-if="hasCustomerBrand" class="auth-customer-brand">
                <span class="auth-customer-brand__label">Espacio de trabajo</span>
                <CustomerBrandLogo variant="full" context="auth" :alt="customerName" />
              </div>
              <b-form class="auth-form" @submit.prevent="recovery">
                <div class="auth-heading">
                  <div class="auth-panel-header">
                    <AppIcon name="key" />
                    <span class="auth-panel-title">Recuperar contraseña</span>
                  </div>
                  <p>Te enviaremos las instrucciones para volver a ingresar a tu cuenta.</p>
                </div>

                <b-form-group label="Correo electrónico" class="auth-field">
                  <b-input-group class="auth-input-group">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <AppIcon name="mail" />
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="email" class="form-control" placeholder="tu@email.com" autocomplete="email" v-model="form.email"/>
                  </b-input-group>
                </b-form-group>
                <b-button type="submit" variant="primary" class="auth-submit primary-background">
                  <AppIcon name="send" class="mr-2" /> RECUPERAR
                </b-button>

                <div class="auth-actions">
                  <b-button variant="link" class="auth-link" @click="ir('login')">
                    <AppIcon name="arrow_back" /> Volver a iniciar sesión
                  </b-button>
                </div>
              </b-form>
            </b-card-body>
          </b-card>
          </main>
        </b-col>
      </b-row>

    </div>
  </div>
</template>

<script>
  import Error from '@/handler/error'
  import Session from '@/handler/session'
  import serviceAPI from './services'
  import {EventBus} from '@/handler/event-bus'
  import BrandLoginHero from '@/components/branding/BrandLoginHero'
  import Branding from '@/components/branding/branding'
  import CustomerBrandLogo from '@/components/branding/CustomerBrandLogo'

  export default {
    components: {
      BrandLoginHero,
      CustomerBrandLogo,
    },
    data () {
      return {
        brandingVersion: 0,
        form: {
          email: '',
        }
      }
    },
    computed: {
      customerName() {
        const session = Session.getSession()
        return session && session.settings
          ? session.settings.proyect_name || 'Empresa'
          : 'Empresa'
      },
      hasCustomerBrand() {
        this.brandingVersion
        const session = Session.getSession()
        const branding = Branding.resolve(session && session.settings)
        return (branding.logoCustomized && branding.logo) ||
               (branding.iconCustomized && branding.icon)
      },
    },
    created() {
      EventBus.$on('Settings:settings', this.refreshBranding)
    },
    beforeDestroy() {
      EventBus.$off('Settings:settings', this.refreshBranding)
    },
    methods: {
      refreshBranding() {
        this.brandingVersion++
      },
      ir(path) {
        if(path == 'login') {
          this.$router.push({ name: 'Login' })
        }
      },
      recovery () {
        let loader = this.$loading.show();

        var result = serviceAPI.recoveryPassword(this.form)        

        result.then((response) => {
          var data = response.data

          loader.hide()
          
          if(data){
            this.$awn.success("Se envío un email a su correo con su nueva clave. (Si el correo no aparece en la bandeja de entrada, revise el spam)")

            this.ir('login')
          } else {
            this.$awn.success("Ups!! Ocurrió un error! Intente más tarde!")
          }
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error))
        });
      }
    },
  }
</script>

<style src="./auth.css"></style>
